import { ContactOptionTopic } from './ContactOptions';

export type ClickOrigin = 'billing' | 'chat' | null;

export type TopicsType =
  | {
      name: string;
      display: string;
    }[]
  | null;

const BASE_TOPICS = [
  {
    name: 'general_support',
    display: 'General Support',
  },
  {
    name: 'partnership_inquiries',
    display: 'Partnership Inquiries',
  },
  {
    name: 'technical_question',
    display: 'Technical Questions',
  },
  {
    name: 'press',
    display: 'Press',
  },
  {
    name: 'permissible_uses',
    display: 'Is my use case allowed?',
  },
  {
    name: 'privacy_opt_out',
    display: 'Remove my info',
  },
  {
    name: 'other',
    display: 'Other',
  },
];

const BILLING_TOPICS = [
  {
    name: 'upgrade',
    display: 'Upgrade my account',
  },
  {
    name: 'cancel',
    display: 'Cancel my account',
  },
  {
    name: 'billing',
    display: 'Billing FAQ',
  },
];

const CHAT_TOPICS = [
  {
    name: 'cancel',
    display: 'Cancel my account',
  },
  {
    name: 'agent',
    display: 'Talk to an agent',
  },
];

export const buildDefaultTopics = (
  clickOrigin: ClickOrigin,
  customTopics?: TopicsType,
  customBillingTopics?: TopicsType,
  isInDownsellVariation?: boolean
) => {
  if (customTopics) {
    return customTopics;
  }

  let billingTopics = customBillingTopics || [...BILLING_TOPICS];

  if (isInDownsellVariation) {
    billingTopics = billingTopics.filter(
      (topic) => topic.name !== 'modify' && topic.name !== 'upgrade'
    );

    billingTopics = [
      { name: 'modify', display: 'Modify my account' },
      ...billingTopics,
      { name: 'upgrade', display: 'Upgrade my account' },
    ];
  }

  if (clickOrigin === 'chat') {
    return CHAT_TOPICS;
  }
  if (clickOrigin === 'billing') {
    return customBillingTopics || BILLING_TOPICS;
  }

  return [...billingTopics, ...BASE_TOPICS];
};

export const buildSupportTopics = (
  clickOrigin: ClickOrigin,
  customPlanLink: string,
  customPlanDisplay?: string,
  customTopics?: TopicsType,
  customBillingTopics?: TopicsType,
  isInDownsellVariation?: boolean
): ContactOptionTopic[] => {
  const defaultTopics = buildDefaultTopics(
    clickOrigin,
    customTopics,
    customBillingTopics,
    isInDownsellVariation
  );

  if (customTopics) {
    return customTopics;
  }

  const customEvents = [
    {
      eventAction: 'custom plan form',
      eventCategory: 'upgrade',
      eventLabel: 'contact form modal',
    },
    {
      eventAction: 'select',
      eventCategory: 'contact us',
      eventLabel: 'custom plan',
    },
  ];
  const customPlanTopic = {
    name: 'custom_larger_plan',
    display: customPlanDisplay || 'Request custom/larger plan',
    customLink: customPlanLink,
    customEvents,
  };

  return [...defaultTopics, customPlanTopic];
};
